import React, { memo, useRef, useState, useEffect } from 'react';
import fetchJsonp from 'fetch-jsonp';
import * as Styles from 'src/styles/header.module.scss';

interface ItemCountProps {
    shopifyUrl?: string;
}

const CartItemCount = ({ shopifyUrl }: ItemCountProps) => {
    const isMounted = useRef(false);
    const [itemsCount, setItemsCount] = useState(0);

    useEffect(() => {
        isMounted.current = true;

        const getCart = async () => {
            const jsonpShopifyUrl = shopifyUrl || 'https://www.pvolve.com';

            try {
                const response = await fetchJsonp(`${jsonpShopifyUrl}/cart.json`);
                const cartData = await response.json();

                if (isMounted.current) {
                    setItemsCount(cartData?.item_count || 0);
                }
            } catch (error) {
                setItemsCount(0);
            }
        };

        getCart();

        return () => {
            isMounted.current = false;
        };
    }, [shopifyUrl]);

    return (
        <span className={`${Styles.itemCount} semibold`}>{itemsCount > 0 ? itemsCount : ''}</span>
    );
};

export default memo(CartItemCount);
